/* ---------------------------------------------------------------------
   داده‌ها و توابع محاسباتی — بر مبنای آیین‌نامه تعرفه حق‌الوکاله و
   ماده ۱۰۳ قانون مالیات‌های مستقیم
--------------------------------------------------------------------- */

export function tieredFinancialFee(amount) {
  // تا ۵۰۰م: ۸٪ / ۵۰۰م-۲میلیارد: ۷٪ / ۲-۱۰میلیارد: ۵٪ / ۱۰-۳۰میلیارد: ۴٪ / بیش از ۳۰میلیارد: ۳٪
  const tiers = [
    { limit: 500_000_000, rate: 0.08 },
    { limit: 2_000_000_000, rate: 0.07 },
    { limit: 10_000_000_000, rate: 0.05 },
    { limit: 30_000_000_000, rate: 0.04 },
    { limit: Infinity, rate: 0.03 },
  ];
  let remaining = amount;
  let prev = 0;
  let fee = 0;
  for (const t of tiers) {
    const bracket = t.limit - prev;
    const inBracket = Math.min(remaining, bracket);
    if (inBracket > 0) fee += inBracket * t.rate;
    remaining -= inBracket;
    prev = t.limit;
    if (remaining <= 0) break;
  }
  return fee;
}

export function specializedBodyNotionalFee(amount) {
  // ماده ۱۰۳ بند د — صرفاً برای محاسبه تمبر مالیاتی در مراجع اختصاصی غیرقضایی
  if (amount <= 0) return 0;
  if (amount <= 10_000_000) return amount * 0.05;
  if (amount <= 30_000_000)
    return 10_000_000 * 0.05 + (amount - 10_000_000) * 0.04;
  return 10_000_000 * 0.05 + 20_000_000 * 0.04 + (amount - 30_000_000) * 0.03;
}

export function stampBreakdown(stampAmount, association) {
  // طبق فایل اکسل مرجع: جمع تمبر = خودِ تمبر پایه + نصف آن (صندوق/مرکز) + یک‌چهارم آن (فقط اعضای کانون، بابت هزینه کانون)
  if (association === "markaz") {
    const fundShare = stampAmount * 0.5;
    return {
      fundShare,
      fundLabel: "مرکز امور وکلا و مشاوران قوه قضائیه",
      barShare: 0,
      total: stampAmount + fundShare,
    };
  }
  const fundShare = stampAmount * 0.5;
  const barShare = stampAmount * 0.25;
  return {
    fundShare,
    fundLabel: "صندوق حمایت وکلا و کارگشایان",
    barShare,
    total: stampAmount + fundShare + barShare,
  };
}
